export const hideScrollbar = `
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
        display: none;
    }
`;

export const disableMouseEvents = `
  pointer-events: none;
  user-select: none;
`;
